import { useEffect, useState } from 'react'

import { EMPTY_LIST } from '../../../../../constants/common'
import {
  getMockFieldOwnership,
  OWNERSHIP_ENTITY_ALL,
} from '../../../RentalPortalIntegrations'
import { PROVENANCE_OWNERSHIP_PAGE_SIZE } from '../../RentalPortalProvenance.constants'
import { getIsProvenanceOwnershipOfField } from '../../RentalPortalProvenance.utils'

// TODO: served by the fixture until `GET /api/v3/integration/field-ownership/`
// exists; the matrix is tenant configuration, so one read covers the screen
export function useRentalPortalFieldOwnership() {
  const [items, setItems] = useState(EMPTY_LIST)

  useEffect(() => {
    getMockFieldOwnership({
      entity: OWNERSHIP_ENTITY_ALL,
      page: 1,
      page_size: PROVENANCE_OWNERSHIP_PAGE_SIZE,
    })
      .then(({ data }) => {
        setItems(data.items)
      })
      .catch(() => {
        setItems(EMPTY_LIST)
      })
  }, [])

  function getFieldOwnership({ entity, field }) {
    return (
      items.find(ownership =>
        getIsProvenanceOwnershipOfField({ entity, field, ownership })
      ) ?? null
    )
  }

  return { getFieldOwnership }
}
